import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FilterSelectCascade } from 'components/molecules';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

import { FinancialIndicatorsService } from 'services';
import { StatisticsIndicatorsContext } from '../contexts';

const financialIndicatorsService = new FinancialIndicatorsService();
const { modulesMap: modules, modulesTitlesMap, modulesTitlesMapEn, modulesByi18nKey } = financialIndicatorsService;

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(4),
    color: 'black',
  },
  selectCascade: {
    '& .MuiSelect-select': {
      whiteSpace: 'pre-wrap',
    },
  },
}));

const Hero = (props) => {
  const { className, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles();
  const { t } = useTranslation();
  const { filters, setFilters, setChartTitle } = useContext(StatisticsIndicatorsContext);
  const [indicators, setIndicators] = useState([]);
  const [formulasData, setFormulasData] = useState(
    Object.keys(modules).reduce((prev, curr) => ({ ...prev, [curr]: [] }), {}),
  );

  useEffect(() => {
    financialIndicatorsService.getFormulas().then((data) => {
      setIndicators(data);
    });
  }, []);

  useEffect(() => {
    indicators.forEach((indicator) => {
      if (window.localStorage.getItem('locale') === 'en') {
        setFormulasData((prev) => ({
          ...prev,
          [modulesTitlesMapEn[indicator.description]]: indicator.children,
        }));
      } else {
        setFormulasData((prev) => ({
          ...prev,
          [modulesTitlesMap[indicator.description]]: indicator.children,
        }));
      }
    });
  }, [indicators]);

  useEffect(() => {
    if (!filters?.module || !filters?.formulaId || !formulasData || !formulasData[filters.module]) {
      return;
    }

    const { item: selectedItem, path } =
      financialIndicatorsService.searchTree({ children: formulasData[filters.module] }, filters.formulaId) || {};

    if (!selectedItem) return;

    const moduleSelected = { description: t(modulesByi18nKey[filters.module]) };

    const fullTitle = [moduleSelected, ...path, selectedItem]
      .filter((x) => x.description)
      .map((x) => x.description)
      .join(' / ');

    setChartTitle(selectedItem.description);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formulasData[filters.module], filters.module, filters.formulaId]);

  const handleFilterChange = (module) => (event) => {
    setFilters((prev) => ({
      ...prev,
      module,
      formulaId: event.target.value,
    }));
  };

  const getFilterValue = (module) => {
    if (filters.module === module) {
      return filters.formulaId;
    }

    return '';
  };

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item md={12} xs={12}>
          <FilterSelectCascade
            className={classes.selectCascade}
            placeholder={t('FINANCIAL_STATISTICS.LOCAL_AUTONOMY')}
            startText={t('FINANCIAL_STATISTICS.LOCAL_AUTONOMY') + ': '}
            icon='Statistics/FunksionetDeleguara'
            onChange={handleFilterChange(modules['localAutonomy'])}
            items={formulasData['localAutonomy']}
            value={getFilterValue(modules['localAutonomy'])}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <FilterSelectCascade
            className={classes.selectCascade}
            placeholder={t('FINANCIAL_STATISTICS.REVENUES')}
            icon='Statistics/TeArdhurat'
            startText={t('FINANCIAL_STATISTICS.REVENUES') + ': '}
            onChange={handleFilterChange(modules.revenue)}
            items={formulasData.revenue}
            value={getFilterValue(modules.revenue)}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <FilterSelectCascade
            className={classes.selectCascade}
            placeholder={t('FINANCIAL_STATISTICS.EXPENDITURES')}
            icon='Statistics/Shpenzimet'
            startText={t('FINANCIAL_STATISTICS.EXPENDITURES') + ': '}
            onChange={handleFilterChange(modules.expenditure)}
            items={formulasData.expenditure}
            value={getFilterValue(modules.expenditure)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
